import React from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./filtroIdeCort.css";
import "./filter.css";
import "./main.js";
import lupa from "../../../assets/img/lupa.png";
import { useCounter } from "../../../hooks/useCounter";
import { useAxios, useAxios2, useAxios3 } from "../../../hooks/useAxios";
import IdeaCortaTod from "../ideaCortaTod/IdeaCortaTod";
import ir from "../../../assets/img/ir_acti.png";
import ir2 from "../../../assets/img/ir_2.png";
import regresa from "../../../assets/img/regresa.png";
import regresa2 from "../../../assets/img/ir_izq.png";
import Modal from "../../../components/modal/Modal";
import InputIcon from "../../../components/inputIcon/InputIcon";
import { useNavigate } from 'react-router-dom';
// Assets - icons
import arrowDownIcon from "../../../assets/img/flech_abaj.png";
import { useLocation } from "react-router-dom";
import ModalVideo from "../../../components/modal/ModalVideo.jsx";

<script
  src="https://kit.fontawesome.com/2c36e9b7b1.js"
  crossorigin="anonymous"
></script>;

//const pagin = [1, 2, 3, 4, 5]; //, 9, 10];
//const pagin_mov = [1, 2, 3, 4, 5];

const FiltroIdeCort = () => {
  const [t, i18n] = useTranslation("ideaCorta");
  const [t2] = useTranslation("biblioteca");
  const { counter, increment, decrement, resetCounter, defaultValue } =
    useCounter(0);
  const navigate = useNavigate();

  const [toppage, setToppage] = useState(10);
  const [toppage_mov, setToppage_mov] = useState(4);

  const [ficha, setFicha] = useState(8);
  const [tipob, setTipob] = useState(0);

  const [totales, setTotales] = useState(0);
  const [totales2, setTotales2] = useState(0);
  const [limites, setLimites] = useState(8);
  const [limites2, setLimites2] = useState(6);

  const [pagin, setPagin] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);
  const [pagin_mov, setPagin_mov] = useState([1, 2, 3, 4, 5]);
  const [date, setDate] = useState(null);
  const [url, setUrl] = useState(
    `ideas/gnideas?offset=${counter * ficha}&next=8&lang=${i18n.language}`
  );

  const [url2, setUrl2] = useState(
    `ideas/gnideas?offset=0&next=80&lang=${i18n.language}`
  );


  const { data, isLoading } = useAxios(url);
  const { data2, isLoading2, error2 } = useAxios3(url2);
  const [ide, setIde] = useState([]);

  const [ide2, setIde2] = useState([]);

  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const clase_mov = (index) => {
    if (index === 0 || index < 2) {
      return "card card1";
    } else if (index > 1 || index < 4) {
      return " card card2";
    }
  };


  useEffect(() => {
    if (data) {
      setIde(data);
    }
  }, [data]);

  useEffect(() => {
    if (data2) {
      setIde2(data2);
      const i = Math.ceil(data2.length / 8);
      const newPagin = Array.from({ length: i }, (_, index) => index + 1);
      const i_mov = Math.ceil(data2.length / 6);

      setPagin(newPagin);
      if (i_mov <= 5) {
        const newPagin2 = Array.from({ length: i_mov }, (_, index) => index + 1);
        setPagin_mov(newPagin2);
        setToppage_mov(i_mov - 1);
      }
      else {
        setPagin_mov([1, 2, 3, 4, 5]);
        setToppage_mov(4);
      }

      if (i != 0) {
        setToppage(i - 1);
      }
      else {
        setToppage(0);
      }
    }
  }, [data2]);

  const { dataS, isLoadingS } = useAxios2(
    `ideas/gnideas?offset=0&next=1000&lang=${i18n.language}`
  );
  const location = useLocation();

  useEffect(() => {
    if (dataS) {
      dataS.map((element, index) => {
        if (location.pathname.includes(element.preview)) {
          if (
            element.tipo === "texto-imagen" ||
            element.tipo === "texto-video" ||
            element.tipo === "video" ||
            element.tipo === "image"
          ) {
            openModal(element.contenido, "", element.preview, element.id);
          }
          if (element.tipo === "carrete") {
            openModal(element.contenido, "carrete", element.preview, element.id);
          }
        }
      });
    }
  }, [dataS]);

  const renderizarMensaje_mov = (tipo, contenido, preview, id, index) => {
    if (index === 0 || index < 2) {
      if (tipo === "texto") {
        return (
          <div>
            {/* <p>TEXTO</p> */}
            <div
              className="text1"
              dangerouslySetInnerHTML={{ __html: contenido }}
            ></div>
          </div>
        );
      } else if (tipo === "imagen") {
        return (
          <div className="card-type-img">
            {/* <p>IMAGEN</p> */}
            <img
              className="img1"
              src={"https://www.ricardosalinas.com" + preview}
              alt="Imagen ideas"
            />
          </div>
        );
      } else if (tipo === "texto-imagen") {
        return (
          <div className="div-txt-img">
            {/* <p>TEXTO-IMAGEN</p> */}
            <button onClick={() => openModal(contenido, "", preview, id)}>
              <img
                className="img1 "
                src={"https://www.ricardosalinas.com" + preview}
                alt="Imagen ideas"
              />
            </button>
            <div
              className="cinta"
              onClick={() => openModal(contenido, "", preview, id)}
            >
              <p className="tit_LB">Leer blog</p>
            </div>
          </div>
        );
      } else if (tipo === "texto-video") {
        return (
          <div className="div-txt-vid">
            {/* <p>TEXTO-VIDEO</p> */}
            <div
              className="playImageContainerMobile"
              onClick={() => openModal(contenido, "", preview, id)}
            >
              <div className="arrow-right" />
            </div>
            <button onClick={() => openModal(contenido, "", preview, id)}>
              <img
                className="img1 "
                src={"https://www.ricardosalinas.com" + preview}
                alt="Imagen ideas"
              />
            </button>
            <div
              className="div_bot_vid"
              onClick={() => openModal(contenido, "", preview, id)}
            ></div>
          </div>
        );
      } else if (tipo === "carrete") {
        return (
          <div>
            {/* <p>CARRETE</p> */}
            <button onClick={() => openModal(contenido, "carrete", preview, id)}>
              <img
                className="img1 "
                src={"https://www.ricardosalinas.com" + preview}
                alt="Imagen ideas"
              />
            </button>
            <div
              className="cinta"
              onClick={() => openModal(contenido, "carrete", preview, id)}
            >
              <p className="tit_LB">Ver galería</p>
            </div>
          </div>
        );
      } else if (tipo === "youtube") {
        return (
          <div className="div-youtube-list">
            {/* <p>YOUTUBE</p> */}
            <div className="div-txt-vid">
              <div
                className="playImageContainerMobile"
                onClick={() => openModalVideo(contenido, id)}
              >
                <div className="arrow-right" />
              </div>
              <button onClick={() => openModalVideo(contenido, id)}>
                <img
                  className="img1 "
                  src={"https://www.ricardosalinas.com" + preview}
                  alt="Imagen ideas"
                />
              </button>
              <div
                className="div_bot_vid"
                onClick={() => openModalVideo(contenido, id)}
              ></div>
            </div>
          </div>
        );
      } else if (tipo === "video") {
        return (
          <div className="div-youtube-list">
            {/* <p>VIDEO</p> */}
            <div className="div-txt-vid">
              <div
                className="playImageContainerMobile"
                onClick={() => openModal("https://www.ricardosalinas.com" + contenido, "video", preview, id)}
              >
                <div className="arrow-right" />
              </div>
              <button className="stioYoutube" onClick={() => openModal("https://www.ricardosalinas.com" + contenido, "video", preview, id)}>
                <img
                  className="img1 img_text"
                  src={"https://www.ricardosalinas.com" + preview}
                  alt="Imagen ideas"
                />
              </button>
            </div>
          </div>
        );
      } else {
        return <p>La condición es falsa</p>;
      }
    } else if (index > 1 || index < 4) {
      if (tipo === "texto") {
        return (
          <div className="div_mayor">
            {/* <p>TEXTO-2</p> */}
            <div
              className="text1"
              dangerouslySetInnerHTML={{ __html: contenido }}
            ></div>
          </div>
        );
      } else if (tipo === "imagen") {
        return (
          <div className="div_mayor">
            {/* <p>IMAGEN-2</p> */}
            <div className="card-type-img">
              <img
                className="img1"
                src={"https://www.ricardosalinas.com/" + preview}
                alt="Imagen ideas"
              />
            </div>
          </div>
        );
      } else if (tipo === "texto-imagen") {
        return (
          <div>
            {/* <p>TEXTO-IMAGEN-2</p> */}
            <button onClick={() => openModal(contenido, "", preview, id)}>
              <img
                className="img1 "
                src={"https://www.ricardosalinas.com" + preview}
                alt="Imagen ideas"
              />
            </button>
            <div
              className="cinta"
              onClick={() => openModal(contenido, "", preview, id)}
            >
              <p className="tit_LB">Ver idea</p>
            </div>
          </div>
        );
      } else if (tipo === "texto-video") {
        return (
          <div className="div_mayor">
            {/* <p>TEXTO-VIDEO-2</p> */}
            <button onClick={() => openModal(contenido, "", preview, id)}>
              <img
                className="img1 "
                src={"https://www.ricardosalinas.com" + preview}
                alt="Imagen ideas"
              />
            </button>
            <div
              className="div_bot_vid"
              onClick={() => openModal(contenido, "", preview, id)}
            ></div>
          </div>
        );
      } else if (tipo === "carrete") {
        return (
          <div>
            {/* <p>CARRETE-2</p> */}
            <button onClick={() => openModal(contenido, "carrete", preview, id)}>
              <img
                className="img1 "
                src={"https://www.ricardosalinas.com" + preview}
                alt="Imagen ideas"
              />
            </button>
            <div
              className="cinta"
              onClick={() => openModal(contenido, "carrete", preview, id)}
            >
              <p className="tit_LB">Ver galería</p>
            </div>
          </div>
        );
      } else if (tipo === "youtube") {
        return (
          <div className="div-youtube-list">
            {/* <p>YOUTUBE-2</p> */}

            <div className="div-txt-vid">
              <div
                className="playImageContainerMobile"
                onClick={() => openModalVideo(contenido, id)}
              >
                <div className="arrow-right" />
              </div>
              <button onClick={() => openModalVideo(contenido, id)}>
                <img
                  className="img1 "
                  src={"https://www.ricardosalinas.com" + preview}
                  alt="Imagen ideas"
                />
              </button>
              <div
                className="div_bot_vid"
                onClick={() => openModalVideo(contenido, id)}
              ></div>
            </div>
          </div>
        );
      } else if (tipo === "video") {
        return (
          <div className="div-youtube-list">
            {/* <p>VIDEO-2</p> */}
            <div className="div-txt-vid">
              <div
                className="playImageContainerMobile"
                onClick={() => openModal("https://www.ricardosalinas.com" + contenido, "video", preview, id)}
              >
                <div className="arrow-right" />
              </div>
              <button onClick={() => openModal("https://www.ricardosalinas.com" + contenido, "video", preview, id)}>
                <img
                  className="img1 img_text"
                  src={"https://www.ricardosalinas.com" + preview}
                  alt="Imagen ideas"
                />
              </button>
            </div>
          </div>
        );
      } else {
        return (
          <div className="div_mayor">
            {" "}
            <p>La condición es falsa</p>;
          </div>
        );
      }
    }
    <InputIcon />;
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [id_liga, setId_liga] = useState("");
  const [variable1, setVariable1] = useState("");
  const [variable2, setVariable2] = useState("");

  const [isOpenModalVideo, setIsOpenModalVideo] = useState(false);
  const [urlVideo, setUrlVideo] = useState("");

  const openModal = (value1, value2, value3, value4) => {
    setVariable1(value1);
    setVariable2(value2);
    setId_liga(value4);
    setIsModalOpen(true);
    navigate(`/${i18n.language}/Ideas-en-Corto?idea=${value4}`);
  };

  const closeModal = () => {
    setVariable1("");
    setVariable2("");
    setIsModalOpen(false);
  };

  const openModalVideo = (contenido, value4) => {
    setUrlVideo(contenido);
    setIsOpenModalVideo(true);
    navigate(`/${i18n.language}/Ideas-en-Corto?idea=${value4}`);
  };

  const closeModalVideo = () => {
    setUrlVideo("");
    setIsOpenModalVideo(false);
  };


  const nextButton = vble => {
    if (window.innerWidth <= 768) {
      // Lógica para dispositivos móviles (ancho menor o igual a 768px)
      if (paginaActual != totalPaginas) {
        setFicha(6);
        setVariables(1);
        increment();
        nextPage();
        const targetDivMobile = document.getElementById('id-resultadoss');
        targetDivMobile.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Lógica para desktop (ancho mayor a 768px)
      if (counter < toppage) {
        setFicha(8);
        setVariables(1);
        increment();
        const targetDivDesktop = document.getElementById('id-resultadosesc');
        targetDivDesktop.scrollIntoView({ behavior: 'smooth' });
      }
    }

  };

  const disablbutn = () => {
    if (window.innerWidth <= 768) {
      // Lógica para dispositivos móviles (ancho menor o igual a 768px)
      if (paginaActual != totalPaginas) {
        return false;
      } else {
        return true;
      }
    } else {
      // Lógica para desktop (ancho mayor a 768px)
      if (counter < toppage) {
        return false;
      }
      else {
        return true;
      }
    }
  };




  const options = [
    { value: "Desc", label: t("ideaCort.filtr4") },
    { value: "Asce", label: t("ideaCort.filtr5") },
  ];

  const [inputVal, setInputVal] = useState("");

  const notAllowedChars = [
    '"',
    "`",
    "=",
    ";",
    "[",
    "]",
    "{",
    "}",
    "/",
    "\\",
    "&",
    "<",
    ">",
    ":",
    "'",
  ];

  const handleInputChange = (event) => {
    setInputVal(event.target.value);

    const value = event.target.value;

    // Verificar si el valor contiene algún carácter no permitido
    const containsNotAllowedChars = notAllowedChars.some((char) =>
      value.includes(char)
    );
    let cleanBody = "";

    if (containsNotAllowedChars) {
      event.target.classList.add("invalid");
      for (let character of inputVal) {
        cleanBody += notAllowedChars.includes(character) ? "" : character;
      }
      setInputVal(cleanBody);
    } else {
      event.target.classList.remove("invalid");
    }
  };

  //para movil
  const handleInputChange2 = (event) => {
    setInputVal(event.target.value);
  };

  const setVariables = (valu, cuanto) => {
    // Aquí puedes acceder al valor del input, que está en 'inputValue'

    if (tipob == 0) return;
    if (valu == 0) {
      setTotales((counter - 1) * ficha);
      setTotales2((counter - 1) * 6);
      setLimites(((counter - 1) + 1) * ficha);
      setLimites2(((counter - 1) + 1) * 6);
    } else {
      if (valu == 1) {
        setTotales((counter + 1) * ficha);
        setTotales2((counter + 1) * 6);
        setLimites(((counter + 1) + 1) * ficha);
        setLimites2(((counter + 1) + 1) * 6);

      }
      else {
        setTotales(cuanto * ficha);
        setTotales2(cuanto * 6);
        setLimites((cuanto + 1) * ficha);
        setLimites2((cuanto + 1) * 6);
      }
    }
  };

  function isMobile() {
    return window.innerWidth <= 768; // Puedes ajustar este valor según tus necesidades
  }

  const handleClick = () => {
    // Aquí puedes acceder al valor del input, que está en 'inputValue'
    if (inputVal.length <= 1) return;
    setFicha(8);
    setTipob(1);
    resetCounter();
    setUrl(`ideas/searchbytitle?words=${inputVal}&lang=${i18n.language}`);
    setUrl2(`ideas/searchbytitle?words=${inputVal}&lang=${i18n.language}`);

    const targetDivMobile = document.getElementById('id-resultadoss');
    const targetDivDesktop = document.getElementById('id-resultadosesc');

    // Si el div existe, hacer el desplazamiento
    if (isMobile() || !targetDivDesktop) {
      if (targetDivMobile) {
        targetDivMobile.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      if (targetDivDesktop) {
        targetDivDesktop.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleClickDefault = (value) => {
    setTipob(0);
    resetCounter();
    setFicha(value);
    setTotales(0);
    setTotales2(0);
    setLimites(8);
    setLimites2(4);
    setInputVal('');


    setUrl(`ideas/gnideas?offset=${counter * ficha}&next=8&lang=${i18n.language}`);
    setUrl2(`ideas/gnideas?offset=0&next=80&lang=${i18n.language}`);
  };


  const handleKeyDown = (e) => {
    // Verificar si la tecla presionada es "Enter" (código 13)
    if (e.key === "Enter") {
      handleClick();
    }
  };


  const [optionSelected, setOptionSelected] = useState(null);





  useEffect(() => {
    if (inputVal.length === 0 && date === null) {
      setUrl(
        `ideas/gnideas?offset=${counter * ficha}&next=8&lang=${i18n.language}`
      );
      setUrl2(`ideas/gnideas?offset=0&next=80&lang=${i18n.language}`);
    } else if (inputVal.length >= 1) {
      if (date != null) {
        setUrl(
          `/ideas/searchbytitle?words=${inputVal}&lang=${i18n.language}&sort=${date}`
        );
        setUrl2(
          `/ideas/searchbytitle?words=${inputVal}&lang=${i18n.language}&sort=${date}`
        );
      } else {
        setUrl(`/ideas/searchbytitle?words=${inputVal}&lang=${i18n.language}`);
        setUrl2(`/ideas/searchbytitle?words=${inputVal}&lang=${i18n.language}`);
      }
    } else {
      setUrl(
        `ideas/gnideas?offset=${counter * ficha}&next=8&lang=${i18n.language
        }&sort=${date}`
      );
      setUrl2(
        `ideas/gnideas?offset=0&next=80&lang=${i18n.language}&sort=${date}`
      );
    }
  }, [date, counter, ficha, i18n.language]);


  const elementosMostrados = 6;
  const totalPaginas = Math.ceil(ide2?.length / elementosMostrados);
  const [paginaActual, setPaginaActual] = useState(1);
  const [paginasVisibles, setPaginasVisibles] = useState([]);

  useEffect(() => {
    const generarPaginasVisibles = () => {
      let paginaInicial, paginaFinal;

      // Caso 1: Menos de 5 páginas en total
      if (totalPaginas <= 5) {
        paginaInicial = 1;
        paginaFinal = totalPaginas;
      } else {
        // Caso 2: Más de 5 páginas en total
        if (paginaActual < 5) {
          // Estamos en las primeras 5 páginas
          paginaInicial = 1;
          paginaFinal = 5;
        } else if (paginaActual + 4 >= totalPaginas) {
          // Estamos en las últimas 5 páginas
          paginaInicial = totalPaginas - 4;
          paginaFinal = totalPaginas;
        } else {
          // Estamos en el medio de las páginas
          paginaInicial = paginaActual - 2;
          paginaFinal = paginaActual + 2;
        }
      }

      // Generar la lista de páginas visibles
      const paginas = [];
      for (let i = paginaInicial; i <= paginaFinal; i++) {
        paginas.push(i);
      }

      setPaginasVisibles(paginas);
    };

    generarPaginasVisibles();
  }, [paginaActual, totalPaginas]);

  const nextPage = () => {
    setPaginaActual(
      paginaActual === totalPaginas ? totalPaginas : paginaActual + 1
    );
  };

  const prevPage = () => {
    setPaginaActual(paginaActual === 1 ? 1 : paginaActual - 1);
  };

  const onChangeSortInput = (option) => {
    setOptionSelected(option);
    setDate(option?.value);
  };

  const [showOptions, setShowOptions] = useState(false);
  const [orderValue, setOrderValue] = useState("");

  const clearSearch = () => {
    setInputVal('');
  };

  return (
    <div className="ideas-cort-FiIdeLi">


      <div id="id-resultadosesc" className="filter-container">
        <div className="filter-column">
          <p style={{ marginBottom: "10px" }}>{t("ideaCort.filtr1")}</p>
          <div id="input" className={`${isVisible ? 'visible24' : 'hidden24'}`}>
            <input
              type="text"
              placeholder={t("ideaCort.filtr3")}
              value={inputVal}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
            />
            {inputVal && (
                <button
                  onClick={clearSearch}
                  style={{
                    position: 'absolute',
                    right: '55px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '24px',
                    color: '#888',
                  }}
                >
                  &#x2715; {/* Esto es el símbolo de "X" */}
                </button>
              )}
            <img src={lupa} onClick={handleClick} />
          </div>
        </div>
        <div className={`filter-column ${isVisible ? 'visible24' : 'hidden24'}`}>
          <p style={{ marginBottom: "10px"}}>{t("ideaCort.filtr2")}</p>
          <div id="input">
            <div id="order-value">{orderValue}</div>
            <img
              id="arrow-image"
              src={arrowDownIcon}
              onClick={() => {
                setShowOptions(!showOptions);
              }}
            />
            <div
              id="options-container"
              className={!showOptions ? "disabled" : ""}
            >
              <div
                className="not-last"
                onClick={(e) => {
                  setOrderValue(options[0].label);
                  onChangeSortInput(options[0]);
                  setShowOptions(false);
                }}
              >
                <p
                  onClick={(e) => {
                    setOrderValue(options[0].label);
                    onChangeSortInput(options[0]);
                    setShowOptions(false);
                  }}
                >
                  {options[0].label}
                </p>
              </div>
              <div
                onClick={(e) => {
                  setOrderValue(options[1].label);
                  onChangeSortInput(options[1]);
                  setShowOptions(false);
                }}
              >
                <p
                  onClick={(e) => {
                    setOrderValue(options[1].label);
                    onChangeSortInput(options[1]);
                    setShowOptions(false);
                  }}
                >
                  {options[1].label}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className={`btn-ide-cr-bn filter-column filter-column2b ${isVisible ? 'visible24' : 'hidden24'}`}>
          <p style={{ color: "white" }}>
            {t("ideaCort.filtr2")}
          </p>
          <button
            style={{ marginTop: "0.5em" }}
            className="buton_IC"
            onClick={() => {
              handleClickDefault(12);
            }}
          >
            {t("ideaCort.filtr7")}
          </button>
        </div>
        <div id="id-resultadoss" className="filter-column only-mov-i">
          <div className="filter-column-b">

            <button className="btn-tog" onClick={toggleVisibility}>
              <img
                className={isVisible ? 'rotated' : ''} // Aplica la clase 'rotated' cuando isVisible es true
                src={lupa}
              />
            </button>
          </div>
          <div className="line"></div>

        </div>
      </div>



      <div className="ideas-cort solo-tm-g">
        <div className="contenedor_IdeCort escritorio_idCorTod">
          <div className="row1_LB">
            <p className="result">
              {" "}
              {t("ideaCort.result1")} {((counter) * 8) + (ide ? ide.length : 0)}{t2("biblioteca.of")}{(ide2 ? ide2.length : 60)}{" "}
              {t("ideaCort.result2")}
            </p>
            <br></br>
          </div>
          {isLoading && data === null ? (
            // (<div>    <h1>cargando...</h1></div>) :
            <div>
              {" "}
              <h1>{t("ideaCort.cargan")}</h1>
            </div>
          ) : (
            <IdeaCortaTod dataideas={ide} totale={totales} limite={limites} />
          )}
          {/* numeros de paginado */}
          <div id="column-left" className="escritorio_idCorTod">
            <div className="column-left-sticky">
              <div className="row6_LB" style={{ cursor: "pointer" }}></div>
              {/* Boton hacia adelante */}
              <div
                className="row6_LB"
                onClick={() => {
                  if (counter < toppage) {
                    setFicha(8);
                    setVariables(1);
                    increment();
                  }
                }}
              >
                {counter > 0 && data === null ? (
                  <img className="imgPag_LB" src={ir2} alt="regresa" />
                ) : (
                  <img
                    className="imgPag_LB cursorPointer"
                    src={ir}
                    alt="regresa"
                  />
                )}
              </div>
              {/* Boton hacia atras */}
              <div
                className="row6_LB"
                onClick={() => {
                  if (counter > 0) {
                    setFicha(8);
                    setVariables(0);
                    decrement();
                  }
                }}
              >
                {counter > 0 ? (
                  <img
                    className="imgPag_LB cursorPointer"
                    src={regresa2}
                    alt="regresa"
                  />
                ) : (
                  <img className="imgPag_LB" src={regresa} alt="regresa" />
                )}
              </div>
              {/* Numeros de paginado */}
              {pagin.map((item, index) => (
                <div
                  key={index}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setFicha(8);
                    setVariables(2, index);
                    defaultValue(index);
                  }}
                  div
                  className="row6_LB"
                >
                  <p
                    className={
                      counter === index ? "numeros_paginado_idea_corta" : ""
                    }
                  >
                    {item}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className="row3_LB">
            <p className="result">
              {" "}
              {t("ideaCort.result1")} {((counter) * 8) + (ide ? ide.length : 0)}{t2("biblioteca.of")}{(ide2 ? ide2.length : 60)}{" "}
              {t("ideaCort.result2")}
            </p>
          </div>
        </div>

        {/* aqui va lo de movil */}

        <div className="contenedor_IdeCort movil_idCorTod ">
          <div className="column-arriba">
            <div className="media-val">
              <p className="result">
                {t("ideaCort.result1")} {((counter) * 6) + (ide ? ide.slice(0, 6).length : 0)}{t2("biblioteca.of")}{(ide2 ? ide2.length : 60)}{" "}
                {t("ideaCort.result2")}
              </p>
            </div>
            <div class="contenedor-paginacion-movil">
              {/* Boton para ir hacia atras */}
              <div className="contenedor-btn">
                <img
                  className="imagen-izquierda"
                  onClick={() => {
                    if (counter > 0) {
                      setFicha(6);
                      setFicha(6);
                      setVariables(0);
                      decrement();
                      prevPage();
                    }
                  }}
                  src={`${paginaActual > 1
                    ? "/assets/imgs/detalle_blog/arrow.png"
                    : "/assets/imgs/detalle_blog/regresa.png"
                    }`}
                  disabled={paginaActual === 1 ? true : false}
                />
              </div>

              {/* Ellipisis para mostrar si es mas de las 5 primeras */}
              {paginaActual >= 5 && <a>...</a>}

              {/* Paginas visibles */}
              {paginasVisibles.map((page) => (
                <a
                  key={page}
                  className={`${page === paginaActual
                    ? "active numeros_paginado_idea_corta_movil"
                    : ""
                    }`}
                  onClick={() => {
                    setFicha(6);
                    setFicha(6);
                    setVariables(2, page - 1);
                    defaultValue(page - 1);
                    setPaginaActual(page);
                  }}
                >
                  {page}
                </a>
              ))}
              {/* Ellipisis para mostrar si no es las 5 ultimas */}
              {paginaActual < totalPaginas - 4 ? <a>...</a> : null}

              {/* Boton para ir hacia adelante */}
              <div className="contenedor-btn">
                <img
                  className="imagen-derecha"
                  onClick={() => {
                    if (counter < (totalPaginas - 1)) {
                      setFicha(6);
                      setFicha(6);
                      setVariables(1);
                      increment();
                      nextPage();
                    }
                  }}
                  src={`${paginaActual === totalPaginas
                    ? "/assets/imgs/detalle_blog/ir_2.png"
                    : "/assets/imgs/detalle_blog/ir_acti.png "
                    }`}
                  disabled={paginaActual === totalPaginas ? true : false}
                />
              </div>
            </div>
          </div>
          <div className="row2_LB esc movil_idCorTod2">
            <div className="list_content--items">
              {ide.slice(totales2, limites2).map((item, index) => (
                <div className={clase_mov(index)} key={index}>
                  <div className="div-card-1">
                    {renderizarMensaje_mov(
                      item.tipo,
                      item.contenido,
                      item.preview,
                      item.id,
                      index
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="row3_LB">
            <p className="result">
              {" "}
              {t("ideaCort.result1")} {((counter) * 6) + (ide ? ide.slice(0, 6).length : 0)}{t2("biblioteca.of")}{(ide2 ? ide2.length : 60)}{" "}
              {t("ideaCort.result2")}
            </p>
          </div>
        </div>

        <Modal
          isOpen={isModalOpen}
          closeModal={closeModal}
          variable1={variable1}
          variable2={variable2}
          id_idea={id_liga}
        />

        <ModalVideo
          isOpen={isOpenModalVideo}
          closeModal={closeModalVideo}
          urlVideo={urlVideo}
        />

        <div className="contenedor_IdeCort1 ">
          <div className="row4_LB">
            <div className="div_bot2_LB">
              <button className="navbar_suscribirse" onClick={() => nextButton('someValue')} disabled={disablbutn()}>
                {t("ideaCort.conoce")}
              </button>
            </div>
          </div>
          {/*  hasta aqui es la parte de la historia 1298 */}
        </div>
      </div>
    </div>
  );
};
export default FiltroIdeCort;
